import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePickByLanguage } from '@/hooks/use-pick-by-language'
import { useAppSelector } from '@/app/hooks'
import { CustomDesignStyle } from '@/components/template/custom-design-style'
import { GoogleMapCopyLink } from '@/components/organisms/survey/google-map-copy-link'
import { OkImage } from '@/components/atoms/icon'
import { css } from '@emotion/react'
import { Button, BorderButton } from '@/components/atoms/button'
import { useNavigate } from 'react-router-dom'
import { OtherPlatformLink } from '@/components/atoms/other-platform-link'

/**
 * アンケート完了ページ
 * アンケート回答完了後に表示されるサンクスページ
 * NPSスコアが9以上でGoogle Mapsが有効な場合、Google Mapsレビューへの誘導を表示
 */
export const SurveyThanks = () => {
  const { t } = useTranslation()
  const pickByLanguage = usePickByLanguage()
  const navigate = useNavigate()
  // Reduxからアンケート結果を取得
  const surveyResult = useAppSelector(state => state.survey.surveyResult.result)

  return (
    <>
      <CustomDesignStyle />
      <div css={layoutStyle}>
        <OkImage css={imageWrapperStyle} />
        <h2 css={thanksMessageStyle}>{t('You have completed the survey.')}</h2>
        {!surveyResult?.googleMapEnabled ? (
          // 条件1: GoogleMap無効の場合
          <>
            <p css={[leadStyle, css({ marginBottom: '2rem' })]}>
              {t('Thank you very much for your cooperation with the survey.')}
              <br />
              {t('We will use your feedback to strive to provide better service.')}
            </p>
            <Button text={t('TOP')} onClick={() => navigate('/')} css={buttonStyle} />
          </>
        ) : surveyResult.recommendation === 'recommended' ? (
          // 条件2: 推奨 + GoogleMap有効の場合
          <>
            <p css={[leadStyle, css({ marginBottom: '2rem' })]}>
              {t('Thank you for your wonderful feedback!')}
              <br />
              {t('We’d appreciate it if you could leave a review on Google Maps.')}
            </p>
            {/* フィードバックコメントをコピーしてGoogle Mapsレビューに誘導するコンポーネント */}
            <GoogleMapCopyLink comment={pickByLanguage(surveyResult?.comment)} googleMapUrl={surveyResult?.googleMapUrl || ''} />
            <BorderButton text={t('TOP')} onClick={() => navigate('/')} buttonCss={[buttonStyle]} />
          </>
        ) : (
          // 条件3: 推奨しない + GoogleMap有効の場合
          <>
            <p css={[leadStyle, css({ marginBottom: '2rem' })]}>
              {t('Thank you for your valuable feedback.')}
              <br />
              {t('We sincerely value your feedback and will do our best to make improvements.')}
            </p>
            <Button text={t('TOP')} onClick={() => navigate('/')} css={buttonStyle} />
            <OtherPlatformLink url={surveyResult?.googleMapUrl || ''} />
          </>
        )}
      </div>
    </>
  )
}
const layoutStyle = css({
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '6rem',
  paddingRight: '1.5rem',
  paddingLeft: '1.5rem',
  overflowY: 'auto',
})

const thanksMessageStyle = css({
  fontSize: '22px',
  marginTop: '2.5rem',
  marginBottom: '2rem',
  textAlign: 'center',
  lineHeight: '1.54',
  whiteSpace: 'pre-wrap',
})

const leadStyle = css({
  textAlign: 'center',
  fontSize: '14px',
  lineHeight: '1.8',
  whiteSpace: 'pre-wrap',
})

const imageWrapperStyle = css({
  width: '182px',
  height: '182px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const buttonStyle = css({
  marginTop: '2.5rem',
  marginBottom: '1.5rem',
})
